import { createStyles } from '@mantine/core';

import type { BadgeSize } from './types';
import { BADGE_SIZES } from './types';

interface BadgeStylesProps {
  size?: BadgeSize;
  width?: number;
  height?: number;
  backgroundColor?: string;
}

const useStyles = createStyles(
  (theme, { size = 'medium', width, height, backgroundColor }: BadgeStylesProps) => {
    const finalSize =
      width && height ? { size: width, iconHeight: height * 0.5 } : BADGE_SIZES[size];
    const badgeSize = width || finalSize.size;
    const badgeHeight = height || finalSize.size;

    const dynamicPadding = Math.max(Math.round(badgeSize * 0.25), 4);

    return {
      badge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: badgeSize,
        height: badgeHeight,
        borderRadius: '50%',
        backgroundColor: backgroundColor || theme.black,
        flexShrink: 0,
        minWidth: badgeSize,
        minHeight: badgeHeight,
        padding: dynamicPadding,
      },

      iconContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      },
    };
  }
);

export default useStyles;
